/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import ReactGA from 'react-ga'
import _ from 'lodash'
import { browserHistory } from 'react-router'
import TreeView from 'react-treeview'
import classnames from 'classnames'
import { MAP } from 'react-google-maps/lib/constants'
import moment from 'moment'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'
import axios from 'axios'

import {
	getDevicesMetadata as getDevicesMetadataAction,
	getDevicesList,
	getDevicesLastgps,
	getDevicesMetadataLastKnown,
	getDevicesEventUpdates,
	getDeviceAddress
} from '../../../action/DeviceActions'
import { requestCustomAlertVideo } from '../../../action/AlertActions'

import SimpleMapExampleGoogleMap from './TrackTrace/SimpleMapExampleGoogleMap'
import TreeVehicleNode from './TrackTrace/TreeVehicleNode'
import VehicleSidebar from './TrackTrace/VehicleSidebar'
import TripSnapshots from './TrackTrace/TripSnapshots'
import AdvancedPlayer from './AdvancedPlayer'
import EventShareModal from '../modals/EventShareModal'
import EventViewSnapshotModal from '../modals/EventViewSnapshotModal'

import 'react-treeview/react-treeview.css'
import '../../dump/menuComponents/treeview.sass'
import './markerWithLabel.css'
import 'react-datetime/css/react-datetime.css'
import SearchBar from '../../dump/menuComponents/SearchBar'
import EventNoteModal from '../modals/EventNoteModal'
import { apiCall } from '../../../action/RouterActions'
import { isInternalUser } from '../../helpers/constants'
import { formatAddress } from '../../helpers/tablesFuncHelpers'
import CategoryItem from '../../dump/menuComponents/CategoryItem'
import GreyHeader from '../../dump/menuComponents/GreyHeader'
import CustomButton from '../../CustomButton'
import useInterval from '../../common/UseInterval'

const splitBlocks = (e) => {
	e.preventDefault();

	var x = e.pageX - $('#block-tree').offset().left;
	if (x > -1 && x < 3600 && e.pageX < ($(window).width() - 0)) {
		$('#block-tree').css("width", x);
		$('#map-block').css("left", x);
	}
}

function getRandomInRange(from, to, fixed) {
	return (Math.random() * (to - from) + from).toFixed(fixed) * 1
}

function convertAlertName(alert_name) {
	switch (alert_name) {
		case 'InputSensor':
			return 'DriverEvent';
		case 'FatalGSensor':
			return 'HighGForce';
		case 'HddError':
			return 'SDError';
		default:
			return alert_name;
	}
}

// const usePreviousValue = value => {
// 	const ref = useRef();
// 	useEffect(() => {
// 		ref.current = value;
// 	});
// 	return ref.current;
// }

const TrackTraceContainer = (props) => {
	const { user, tripAdvancedPlayerEvent, tripShowShareEvent, showTripsHistory, selectedTrip, toggleLoader, dashboardRedirect, setShowTripsHistory } = props;
	const userRole = user.user.roles[0];

	const prevProps = useRef(props)

	const [map, setMap] = useState(null);
	// const [_map, setMap] = useState(null);
	const _map = useRef()
	const [interval, setIntervalState] = useState(null);
	const [delayInterval, setDelayInterval] = useState(null);
	const [timeline, setTimeline] = useState(null);
	const [state, setState] = useState({
		location: null,
		initDevices: [],
		category: 1,
		autoValue: '',
		groups: [],
		collapsedBookkeeping: [],
		markers: [],
		singleTrucks: [],
		bounds: null,
		alerts: [],
		alertsRemoved: [],
		alert_filters: {
			alert_gsensor: true,
			alert_speed: true
		},
		center: { lat: 37.09024, lng: -95.712891 },
		centerDevice: null,
		zoom: 6,
		maptype: 'roadmap', //'hybrid',
		activeTreeItem: null,

		showTripPanel: false,
		currentTimelineDate: moment(),
		currentTimelineDateData: moment(),
		alertdevices: [],
		playbackSpeed: 2,
		tripHeight: -14,
		additionalClassName: 'tripReplayPanelClosed',
		polygons: [],
		polygonDevice: null,
		alertshistory: {
			items: [],
			groups: []
		},
		moveTo: moment(),

		alertSearchType: 'tt_local',

		selectedEvent: null,
		showAdvancedPlayer: false,
		showEventNote: false,

		company_trace_active: true,
		showLiveTraffic: false,

		popover: {
			show: false,
			left: 0,
			top: 0,
			type: '',
			content: '',
			event: {
				event_type: '',
				event_device_id: 0,
				event_id: 0,
				event_ts: ''
			}
		},

		showVehicleSidebar: false,
		showEventVideoAll: false,
	});

	// useEffect(() => {
	// 	console.log('useEffect _map: ', _map)
	// }, [_map])

	useEffect(() => {
		// debugger
		// console.log('TrackTraceContainer props:', props)
		const { location, tripreplay, company, user } = props
		const { alertdevices, currentTimelineDateData } = state

		traceUserAccess()

		if (location && location.state) {
			/*if (location.state.type === 'redirectFromUnknownDrivers') {
				const locationNew = {
					type: location.state.type,
					unknownDriver: location.state.unknownDriver,
				}	
				setState({...state, location: locationNew })
				browserHistory.replace({ pathname: '/', state: undefined })
			} else*/
			if (location.state.type === 'tripstorage') {
				browserHistory.replace({ pathname: '/', state: undefined })

				window.addEventListener('resize', setMapCenter)
				const toggle = document.getElementsByClassName('toggle-left')[0]
				toggle && toggle.addEventListener('click', setMapCenterTimer)

				// setState({ ...state, ...tripreplay.tripreplay })
				setState((prevState) => {
					return {
						...prevState,
						...tripreplay.tripreplay
					}
				})

				const data = {
					device_ids: alertdevices.map((item, i) => item.device_id).join(','),
					start_ts: moment(currentTimelineDateData).utc().subtract(12, 'hours').format('YYYYMMDDHHmmss'),
					end_ts: moment(currentTimelineDateData).utc().add(12, 'hours').format('YYYYMMDDHHmmss'),
				}
				getDevicesMetadataForTrip(
					data,
					function () { }
				)

				props.updateTripreplay(null)

				return false;
			}
		}

		//* The alerts should be "live" where when the alert occurs. The user should never see an alert from hours previous to them logging in to their account.
		// company.company.company_id && getVehicleList(() => getDevicesMetadataOnline(), company.company.company_id)
		company.company.company_id && getVehicleList((markers) => {getDevicesMetadataOnline(markers)}, company.company.company_id)

		if (user.user.settings) {
			const settings = user.user.settings;
			// setState({ ...state, center: { lat: 37.09024, lng: -95.712891 }, zoom: settings.zoom_level || 6 })
			setState((prevState) => {
				return {
					...prevState,
					center: { lat: 37.09024, lng: -95.712891 }, zoom: settings.zoom_level || 6
				}
			})
		}

		window.addEventListener('resize', setMapCenter);
		const toggle = document.getElementsByClassName('toggle-left')[0];
		toggle && toggle.addEventListener('click', setMapCenterTimer);

		return () => {
			if (interval) {
				clearInterval(interval);
				setIntervalState(null);
			}

			window.removeEventListener('resize', setMapCenter);
			const toggle = document.getElementsByClassName('toggle-left')[0];
			toggle && toggle.removeEventListener('click', setMapCenterTimer);
			document.removeEventListener('mouseup', documentMouseUp);
			// clears the dashboardRedirect props if user was redirected to Homepage from other page/popup (View Trip link of Unknown Drivers popup)
			// FWSD-4405
			// if (props.dashboardRedirect) {
			// props.setDashboardRedirect(null)
			// }
		}
	}, []);

	
	// console.log('!!!!props: ', props)
	// const prevProps = usePreviousValue(5)
	// console.log('!!!!prevProps: ', prevProps.current)

	// const prevAutoValue = useRef('')
	// useEffect(() => {
	// 	if (prevAutoValue.current !== props.autoValue) {
	// 		searchVehicle()
	// 		prevAutoValue.current = props.autoValue
	// 	}		
		
	// }, [props.autoValue])

	useEffect(() => {
		// debugger
		const { activeTreeItem, markers } = state;
		// setState({ ...state, singleTrucks: [] })
		setState((prevState) => {
			return {
				...prevState,
				singleTrucks: []
			}
		})
		// console.log('!!!!prevProps1: ', prevProps.current)
		// debugger
		if (props.showTripsHistory !== prevProps.current.showTripsHistory) {
			// if (props.showTripsHistory) {
			if (props.showTripsHistory && (!dashboardRedirect || (dashboardRedirect.type !== 'redirectFromUnknownDrivers') && dashboardRedirect.type !== 'redirectFromDailyEvents')) {
				const obj = markers.find(item => { if (item.device_id === activeTreeItem.device_id) return item })
				// setState({
				// 	...state,
				// 	polygons: [],
				// 	markers: [{
				// 		...obj,
				// 		... {
				// 			showInfoWindow: false,
				// 		}
				// 	}]
				// })
				setState((prevState) => {
					return {
						...prevState,
						polygons: [],
						markers: [{
							...obj,
							... {
								showInfoWindow: false,
							}
						}]
					}
				})
			} else {
				closeTimeline()
			}
			prevProps.current = props
		}
	}, [props.showTripsHistory]);

	useEffect(() => {
		// debugger
		const { markers } = state;
		if (!_.isEqual(props.tripsGPS, prevProps.current.tripsGPS) || !_.isEqual(props.selectedTrip, prevProps.current.selectedTrip)) {
			if (props.showTripsHistory && props.tripsGPS.length) {
				let pos = props.tripsGPS[0].polygon[0]
				if (pos) {
					// FWSD-4032
					if (props.selectedTrip.isLiveTrip) {
						pos = props.tripsGPS[0].polygon[props.tripsGPS[0].polygon.length - 1]
					}
					const position = { lat: pos.lat, lng: pos.lng }
					// debugger
					// console.log('markers[0]: ', markers[0])
					// if (markers[0]) {
					// 	markers[0].icon_name = markers[0] ? markers[0].entry.vehicle_icon : ''
					// 	markers[0].icon_direction = markers[0] ? getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir) : ''
					// 	markers[0].position = position;
					// 	markers[0].infoData = markers[0] ? Object.assign({}, markers[0].infoData, pos, { driver_name: props.selectedTrip.driver_name }) : ''
					// 	markers[0].visible_icon = true;
					// 	markers[0].driver_name = props.selectedTrip.driver_name;
					// }
					markers[0].icon_name = markers[0].entry.vehicle_icon
					markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir)
					markers[0].position = position;
					markers[0].infoData = Object.assign({}, markers[0].infoData, pos, { driver_name: props.selectedTrip.driver_name })
					markers[0].visible_icon = true;
					markers[0].driver_name = props.selectedTrip.driver_name;

					// console.log('markers: ', markers)

					// setState({ ...state, markers });
					setState((prevState) => {
						return {
							...prevState,
							markers,
						}
					})
				}
				else {
					// setState({ ...state, markers: [] });
					setState((prevState) => {
						return {
							...prevState,
							// markers: []
							markers:[{ ...markers[0], visible_icon: false }]
						}
					})
				}
			}
			prevProps.current = props
		}
	}, [props.tripsGPS, props.selectedTrip]);

	useEffect(() => {
		// debugger
		if (!_.isEqual(props.tripTimelineTimestamp, prevProps.current.tripTimelineTimestamp)) {
			if (props.showTripsHistory && props.tripsGPS.length) {
				const pos = _.find(props.tripsGPS[0].polygon, (item) => {
					return moment(item.timestamp) >= moment(props.tripTimelineTimestamp);
				});

				if (pos) {
					const position = { lat: pos.lat, lng: pos.lng };
					const { markers } = state

					markers[0].icon_name = markers[0].entry.vehicle_icon;
					markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir);
					markers[0].position = position;
					markers[0].infoData = Object.assign({}, markers[0].infoData, pos, { driver_name: props.selectedTrip.driver_name });
					markers[0].visible_icon = true;
					markers[0].driver_name = props.selectedTrip.driver_name;

					// setState({ ...state, markers });
					setState((prevState) => {
						return {
							...prevState,
							markers
						}
					})
				}
			}
			prevProps.current = props
		}
	}, [props.tripTimelineTimestamp]);

	useEffect(() => {
		// debugger
		if (
			!_.isEqual(props.tripAdvancedPlayerEvent, prevProps.current.tripAdvancedPlayerEvent)
			|| !_.isEqual(props.tripShowShareEvent, prevProps.current.tripShowShareEvent)
			// || !_.isEqual(props.tripsGPSSnapRoad, prevProps.tripsGPSSnapRoad)
			|| !_.isEqual(props.showSnapRoad, prevProps.current.howSnapRoad)
		) { }
	}, [props.tripAdvancedPlayerEvent, props.tripShowShareEvent, props.showSnapRoad, /*props.tripsGPSSnapRoad*/]);

	useEffect(() => {
		// debugger
		if ((!props.location || !props.location.state) && (prevProps.current.company.company.company_id !== props.company.company.company_id)) {
			// *The alerts should be "live" where when the alert occurs. The user should never see an alert from hours previous to them logging in to their account.
			traceUserAccess()
			// getVehicleList(() => getDevicesMetadataOnline(), props.company.company.company_id)
			getVehicleList((markers) => {getDevicesMetadataOnline(markers)}, props.company.company.company_id)
			prevProps.current = props
		}
	}, [props.company.company.company_id]);

	useInterval(() => {
		// getDevicesEventUpdates(userRole, company_name, partner_name)
		const markers = state.markers
		const company_name = props.company.company.name
		const partner_name = props.company.company.partner
		const markers_list = markers

		getDevicesEventUpdates(userRole,company_name, partner_name)
			.then((res, err) => {
				let mmm = []
				let _alerts = []
				let followmap_position = null

				// console.log('!!!!!!!getDevicesEventUpdates res.data.response: ', res.data.response)
				if (state.showTripPanel || props.showTripsHistory) {
					const initDevices_list = state.initDevices
					res.data.response.devices.map((item, i) => {
						// let device = _.find(initDevices_list, ['device_id', item.device_id])
						let device = _.find(initDevices_list, (dev) => dev.device_id.toString() === item.device_id.toString())
						if (device) {
							device.online = item.online || device.online
							// device.online_gps   = item.online_gps || device.online_gps
							// device.offline30sec = ( device.online_gps && device.infoData && moment(item.gps.timestamp).diff( moment(device.infoData.timestamp), 'seconds') > 30 )

							mmm.push(device)

							if (item.events && item.events.length) {
								_alerts = _.union(_alerts, fillAlertsArray({ driver_name: device.driver_name, ...item }))
							}
						}

						// FWSD-4032
						if (
							props.selectedTrip
							&& props.selectedTrip.isLiveTrip
							&& item.device_id.toString() === state.activeTreeItem.device_id.toString()
							&& props.tripsGPS.length
						) {
							// Gets the last GPS point (props.tripsGPS[0].polygon) of the Live trip (props.selectedTrip)
							const lastTripsGPSPoint = props.tripsGPS[0].polygon[props.tripsGPS[0].polygon.length - 1]


							// If a trip ends (vehicle idles or goes in parking mode) during a live trip, show the Trip is Processing message
							if (/*!item.online ||*/ !item.ignition.state) {
								// console.log('!!!!!!!!!!! Trip IS Processing')
								// debugger
								props.setSelectedTrip({ ...props.selectedTrip, isLiveTrip: false, isTripProcessing: true })

								const newDeviceTrips = props.deviceTrips.map((devicetrip) => {
									if (devicetrip.route_id === props.selectedTrip.route_id) {
										devicetrip.isLiveTrip = false
										devicetrip.isTripProcessing = true
										devicetrip.end_gps = {
											latitude: (item.gps.lan || lastTripsGPSPoint.lat) * 1,
											longitude: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
											timestamp: item.gps.timestamp,
										}
									}
									return devicetrip
								})
								props.setDeviceTrips(newDeviceTrips)
							}

							// Generates the new last GPS point of the Live trip
							const tripGPSNewPoint = {
								lat: (item.gps.lan || lastTripsGPSPoint.lat) * 1,
								lng: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
								speed: (item.gps.spd || lastTripsGPSPoint.speed) * 1,
								timestamp: moment.utc(item.gps.timestamp).format('YYYY-MM-DD HH:mm:ss'),
								dir: (item.gps.dir || lastTripsGPSPoint.dir) * 1,
								key: ((item.ignition.state || lastTripsGPSPoint.key) * 1).toString(),
								driver_id: lastTripsGPSPoint.driver_id,
								driver_name: lastTripsGPSPoint.driver_name,
								dst: (item.gps.dst || lastTripsGPSPoint.dst) * 1,
							}

							// Stores new last GPS point to the tripsGPS[0].polygon
							props.addTripsGPSPolygonPoint(tripGPSNewPoint)

							// Changes location of the marker on the map
							const item2 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
							// console.log('item2: ', item2)
							if (item2) {
								item2.entry.online = item.hasOwnProperty('online') ? item.online : item2.entry.online
								if (item.gps) {
									const newGPS = item.gps
									if (_.has(newGPS, 'key')) {
										item2.entry.ignition = { ...item2.entry.ignition, state: newGPS.key }
									} else if (_.has(item.ignition, 'state')) {
										item2.entry.ignition = { ...item2.entry.ignition, state: item.ignition.state }
										newGPS.key = item.ignition.state
									}
									item2.icon_direction = getIconDirection(item2.icon_direction || 'e', item2.position, { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
									item2.position = { lat: newGPS.lan * 1 || item2.position.lat, lng: newGPS.lon * 1 || item2.position.lng }
									item2.infoData = Object.assign({}, item2.infoData, newGPS)
									item2.ignitionСhange = Object.assign({}, item2.ignitionСhange, item.ignition)
								}

								// setState({ ...state, markers: [item2] })
								setState((prevState) => { return { 
									...prevState, 
									markers: [item2]
								} })
							}
						}
					})

					const devicestmp = _.uniqWith(_.union(initDevices_list, mmm), _.isEqual)
					const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)

					// setState({ ...state, initDevices: devicestmp, alerts: alertstmp })
					setState((prevState) => { return { 
						...prevState, 
						initDevices: devicestmp, alerts: alertstmp
					} })
				}
				else {
					res.data.response.devices.map((item, i) => {
						// Autoupdate online and ignition properties of the tree selected device
						if (state.activeTreeItem && state.activeTreeItem.device_id === item.device_id) {
							// setState({ ...state, activeTreeItem: { ...state.activeTreeItem, online: item.online, ignition: item.ignition } })
							setState((prevState) => { return { 
								...prevState, 
								activeTreeItem: { ...state.activeTreeItem, online: item.online, ignition: item.ignition }
							} })
						}
						// let item1 = _.find(markers_list, ['device_id', item.device_id])
						let item1 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
						if (item1) {
							item1.entry.online = item.hasOwnProperty('online') ? item.online : item1.entry.online
							// item1.entry.online_gps = item.hasOwnProperty('online_gps') ?  item.online_gps : item1.entry.online_gps
							// item1.entry.offline30sec = false
							if (item.gps) {
								const newGPS = item.gps
								if (_.has(newGPS, 'key')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: newGPS.key }
								} else if (_.has(item.ignition, 'state')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: item.ignition.state }
									newGPS.key = item.ignition.state
								}
								// item1.entry.offline30sec = ( item1.entry.online_gps && item1.infoData && moment(newGPS.timestamp).diff( moment(item1.infoData.timestamp), 'seconds') > 30 )
								item1.icon_direction = getIconDirection(item1.icon_direction || 'e', item1.position, { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
								item1.position = { lat: newGPS.lan * 1 || item1.position.lat, lng: newGPS.lon * 1 || item1.position.lng }
								item1.infoData = Object.assign({}, item1.infoData, newGPS)
								item1.ignitionСhange = Object.assign({}, item1.ignitionСhange, item.ignition)
							}
						}

						mmm = _.union(mmm, [].push(item1))

						if (item.gps && item.gps.lan && item.gps.lon && state.centerDevice && (item.device_id == state.centerDevice.device_id)) {
							followmap_position = { lat: item.gps.lan * 1, lng: item.gps.lon * 1 }
						};
						if (item.events && item.events.length) {
							_alerts = _.union(_alerts, fillAlertsArray({ driver_name: item1.driver_name, ...item }))
						}
					})
					const markerstmp = _.uniqWith(_.union(markers_list, mmm), _.isEqual)
					const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)
					let _state = {
						markers: markerstmp,
						alerts: alertstmp
					}
					if (followmap_position) {
						_state['center'] = { lat: followmap_position.lat, lng: followmap_position.lng }

						setTimeout(() => { google.maps.event.trigger(_map.current.context[MAP], 'resize'); }, 1000)
					}

					// setState({ ...state, ..._state })
					setState((prevState) => { return { 
						...prevState, 
						..._state
					} })
				}//* END if (state.showTripPanel)
			})
			.catch((error) => {
				console.log('!getDevicesEventUpdates error: ', error.response, error)
			})
	}, delayInterval)



	// console.log('markers: ', state.markers)

	const handleMapMounted = (map) => {
		console.log('handleMapMounted map: ', map)

		// setMap((prevMap) => { return { 
		// 	...prevMap, 
		// 	map
		// } })
		// if (map) {
		// 	setMap(map)
		// }
		setMap(map)
	}

	const documentMouseUp = () => {
		// google.maps.event.trigger(_map.context[MAP], 'resize');
		google.maps.event.trigger(_map.current.context[MAP], 'resize');

		document.removeEventListener('mousemove', splitBlocks);
		document.removeEventListener('mouseup', documentMouseUp);

		// setState({ ...state, center: { lat: state.center.lat, lng: state.center.lng } });
		setState((prevState) => { return { ...prevState, center: { lat: state.center.lat, lng: state.center.lng } } })
	}

	const setMapCenterTimer = () => {
		setTimeout(() => google.maps.event.trigger(_map.current.context[MAP], 'resize'), 200);
	}

	const setMapCenter = (a) => {
		google.maps.event.trigger(_map.current.context[MAP], 'resize');
	}

	const getVehicleList = (callback, company_id) => {
		// debugger
		toggleLoader(true);
		const { location } = props

		if (!company_id) {
			return
		}

		getDevicesList(company_id, 'ignition')
			.then(res => {
				// debugger
				toggleLoader(false);

				let devices = res.data.response.devices
				let markers = []

		// 		const { dashboardRedirect, setShowTripsHistory } = props
		// const varMarkers = argMarkers || state.markers

		// if (dashboardRedirect && dashboardRedirect.type) {
		// 	switch (dashboardRedirect.type) {
		// 		case 'redirectFromDailyEvents':
		// 		case 'redirectFromUnknownDrivers':
		// 			const obj = _.find(varMarkers, ['device_id', dashboardRedirect.device_id.toString()])
		// 			if (obj) {
		// 				// setState({ ...state, activeTreeItem: obj.entry, showVehicleSidebar: true })
		// 				setState((prevState) => { return { ...prevState, activeTreeItem: obj.entry, showVehicleSidebar: true } })
		// 				// onTreeDeviceClick(obj.entry)
		// 				setShowTripsHistory(true)
		// 			}
		// 			break;
		// 		default:
		// 			break;
		// 	}
		// }

				devices.map((item, i) => {
					//* Fills the markers array
					if (dashboardRedirect && dashboardRedirect.device_id) {
						if (+item.device_id === +dashboardRedirect.device_id) {
							markers.push({
								position: { lat: 0, lng: 0 },
								icon_name: item.vehicle_icon,
								icon_direction: 'e',
								active: false,
								name: item.vehicle_name || item.device_id,
								device_id: item.device_id,
								entry: item,
								showInfoWindow: false,
								infoData: null,
								ignitionСhange: null,
								visible_icon: false,
							})
						}
					}
					else {
						markers.push({
							position: { lat: 0, lng: 0 },
							icon_name: item.vehicle_icon,
							icon_direction: 'e',
							active: false,
							name: item.vehicle_name || item.device_id,
							device_id: item.device_id,
							entry: item,
							showInfoWindow: false,
							infoData: null,
							ignitionСhange: null,
							visible_icon: false,
						})
					}

					item.start_tracking = true
					// item.online = false
					// item.online_gps = false
					return item
				})

				let result = []
				const groups = _.groupBy(devices, function (device) { return device.group_name; })
				let keys = Object.keys(groups)
				keys = _.sortBy(keys, (num) => num.toLowerCase())

				for (var i = 0; i < keys.length; i++) {
					var k = keys[i]
					result.push({ 'id': k, 'value': groups[k] })
				}

				// setState({
				// 	...state,
				// 	initDevices: devices,
				// 	groups: result,
				// 	markers,
				// 	collapsedBookkeeping: result.map(() => true),
				// 	alerts: [],
				// 	autoValue: '',
				// 	activeTreeItem: null
				// })
				setState((prevState) => { return { 
					...prevState, 
					initDevices: devices,
					groups: result,
					markers,
					collapsedBookkeeping: result.map(() => true),
					alerts: [],
					autoValue: '',
					activeTreeItem: null,
				} })

				// If user come from the Edit Vehicle page by the "return to map" button
				if (location && location.state && location.state.type === 'return_to_map') {
					const obj = _.find(markers, ['device_id', location.state.id])
					if (obj) {
						// setState({
						// 	...state,
						// 	activeTreeItem: obj.entry,
						// 	showVehicleSidebar: true,
						// 	markers
						// });
						setState((prevState) => { return { 
							...prevState, 
							activeTreeItem: obj.entry,
							showVehicleSidebar: true,
							markers,
						} })

						onTreeDeviceClick(obj.entry)
						browserHistory.replace({ pathname: '/', state: undefined })
					}
				}
				// If user come from the UnknownDrivers popup of Driver page by the "View Trip" link
				// FWSD-4405
				// debugger
				getDashboardRedirect(markers)
				/*else if (location && location.state && location.state.type === 'redirectFromUnknownDrivers') { 
					// const obj = _.find(markers, ['device_id',  location.state.unknownDriver.device_id.toString()])
					// console.log('obj: ', obj)
					// if (obj) {
					// 	obj.showInfoWindow = false
					// 	setState({...state, 
					// 			currentTimelineDateData: location.state.unknownDriver.timestamp+'+00',
					// 			currentTimelineDate: moment(location.state.unknownDriver.timestamp+'+00'),
					// 			moveTo: location.state.unknownDriver.timestamp+'+00',
					// 			activeTreeItem: obj.entry,
					// 			showVehicleSidebar: false,
					// 			markers
					// 		});
					// 			startTripReplay()
					// 		}
					// }
				}*/

				if (typeof callback === 'function') {
					// getDevicesMetadataOnline(markers)
					return callback(markers);
				}
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getDevicesList error: ', error);

				setState({
					...state,
					initDevices: [],
					groups: [],
					markers: [],
					collapsedBookkeeping: [],
					alerts: [],
					autoValue: '',
					activeTreeItem: null,
				});

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const getIconDirection = (direction_old, pos_old, pos_new, dir) => {
		let direction = direction_old;

		if (dir && dir > 0) {
			if (dir > 337.5 || dir <= 22.5)
				direction = "n";
			else if (dir > 22.5 && dir <= 67.5)
				direction = "ne";
			else if (dir > 67.5 && dir <= 112.5)
				direction = "e";
			else if (dir > 112.5 && dir <= 157.5)
				direction = "se";
			else if (dir > 157.5 && dir <= 202.5)
				direction = "s";
			else if (dir > 202.5 && dir <= 247.5)
				direction = "sw";
			else if (dir > 247.5 && dir <= 292.5)
				direction = "w";
			else if (dir > 292.5 && dir <= 337.5)
				direction = "nw";
		}
		else {
			const pos1 = new google.maps.LatLng(pos_old);
			const pos2 = new google.maps.LatLng(pos_new);
			let heading = google.maps.geometry.spherical.computeHeading(pos1, pos2);

			if (heading == 0 || (pos_old.lat == 0 && pos_old.lng == 0)) {
				return direction_old;
			}

			if (heading > -24 && heading < 23) {
				direction = 'n';
			}
			else if (heading > -68 && heading < -24) {
				direction = 'nw';
			}
			else if (heading > -113 && heading < -69) {
				direction = 'w';
			}
			else if (heading > -158 && heading < -114) {
				direction = 'sw';
			}
			else if (heading > 23 && heading < 69) {
				direction = 'ne';
			}
			else if (heading > 68 && heading < 114) {
				direction = 'e';
			}
			else if (heading > 113 && heading < 158) {
				direction = 'se';
			}
			else if (heading < -159 || heading > 158) {
				direction = 's';
			}
		}

		return direction;
	}

	const fillAlertsArray = (item) => {
		const { alert_gsensor, alert_speed } = state.alert_filters
		let deviceAlerts = []
		if (item.events && item.events.length) {
			item.events.map((alert, i) => {
				if (alert.id && state.alertsRemoved.indexOf(alert.id) == -1) {
					if (['FatalGSensor', 'GSensor'].indexOf(alert.name) > -1 && !alert_gsensor) {
						return false
					}
					else if (alert.name == "HighSpeed" && !alert_speed) {
						return false
					}

					deviceAlerts.push({
						title: convertAlertName(alert.name),
						starttime: alert.starttime,
						endtime: alert.endtime,
						asset: (item.vehicle_name || item.device_id),
						device_id: item.device_id,
						id: alert.id,
						channel: (alert.channel) ? alert.channel : '',
						driver_name: item.driver_name,
					})
				}
			})
		}
		return deviceAlerts
	}

	const setMarkersBound = () => {
		const { user } = props
		const { bounds } = state

		if (bounds && _map) {
			_map.current.fitBounds(bounds)
			_map.current.panToBounds(bounds)
		}
		else {
			// setState({ ...state, zoom: user.user.settings.zoom_level || 6 })
			setState((prevState) => { return { 
				...prevState,
				zoom: user.user.settings.zoom_level || 6
			} })
		}
	}

	const getDevicesMetadataOnline = (argMarkers=null) => {
		// if (interval) {
		// 	clearInterval(interval)
		// 	setIntervalState(null)
		// }
		if (delayInterval) {
			setDelayInterval(null)
		}

		const { user, company } = props
		// const { markers, activeTreeItem } = state
		// const markers = argMarkers || state.markers
		const company_name = company.company.name
		const partner_name = company.company.partner
		// const markers_list = markers

		if (!company_name || !partner_name) {
			return
		}

		getDevicesLastgps(userRole, company_name, partner_name)
			.then((res, err) => {
				let mmm = []
				let _alerts = []
				let bounds = new google.maps.LatLngBounds()
				let boundsArr = []
				// debugger
				const markers_list = argMarkers || state.markers

				// console.log('getDevicesLastgps!!! res.data.response:', res.data.response)
				// console.log('getDevicesLastgps!!! markers_list:', markers_list)
				res.data.response.devices.map((item, i) => {
					const _markers = markers_list.map((item1, i) => {
						if (item1.device_id == item.device_id) {
							item1.driver_name = item.driver_name
							item1.entry.online = item.online
							// item1.entry.online_gps = item.online_gps
							// item1.entry.offline30sec = false
							item1.visible_icon = false

							const newGPS = item.gps
							if (newGPS && newGPS.lan) {
								if (_.has(newGPS, 'key')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: newGPS.key }
								} else if (_.has(item.ignition, 'state')) {
									item1.entry.ignition = { ...item1.entry.ignition, state: item.ignition.state }
									newGPS.key = item.ignition.state
								}
								// item1.entry.offline30sec = ( item.online_gps && item1.infoData && moment(newGPS.timestamp).diff( moment(item1.infoData.timestamp), 'seconds') > 30 )
								item1.icon_direction = getIconDirection(item1.icon_direction || 'e', item1.position, { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
								item1.position = { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }
								item1.infoData = Object.assign({}, item1.infoData, newGPS)
								item1.ignitionСhange = Object.assign({}, item1.ignitionСhange, item.ignition)
								item1.visible_icon = true
							} else {
								item1.infoData = ''
								item1.ignitionСhange = ''
								item1.position = { lat: 0, lng: 0 }
							}
						}

						return item1
					})

					mmm = _.union(mmm, _markers)

					if (item.gps && item.gps.lan && item.gps.lon) {
						boundsArr.push({ lat: item.gps.lan * 1 || 0, lng: item.gps.lon * 1 || 0 })
					}
					if (item.events && item.events.length) {
						_alerts = _.union(_alerts, fillAlertsArray(item))
					}
				})

				if (boundsArr.length) {
					boundsArr.forEach((item, index) => {
						bounds.extend(item)
					})
					// debugger
					if (_map && _map.current) {
						_map.current.fitBounds(bounds)
						_map.current.panToBounds(bounds)
					}
				}
				else {
					// setState({ ...state, zoom: props.user.user.settings.zoom_level || 6 })
					setState((prevState) => { return { 
						...prevState, 
						zoom: props.user.user.settings.zoom_level || 6
					} })
				}

				const markerstmp = _.uniqWith(_.union(markers_list, mmm), _.isEqual)
				const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)
				// setState({
				// 	...state,
				// 	bounds,
				// 	markers: markerstmp,
				// 	alerts: alertstmp
				// })
				setState((prevState) => { return { 
					...prevState, 
					bounds,
					markers: markerstmp,
					alerts: alertstmp
				} })
			})
			.catch((error) => {
				console.log('!getDevicesLastgps error: ', error);

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response && error.response.data && error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})


		if (state.company_trace_active) {
			setDelayInterval(5000)
			// setIntervalState(setInterval(function () {
			// 	getDevicesEventUpdates(userRole, company_name, partner_name)
			// 		.then((res, err) => {
			// 			let mmm = []
			// 			let _alerts = []
			// 			let followmap_position = null

			// 			// console.log('!!!!!!!getDevicesEventUpdates res.data.response: ', res.data.response)
			// 			if (state.showTripPanel || props.showTripsHistory) {
			// 				const initDevices_list = state.initDevices
			// 				res.data.response.devices.map((item, i) => {
			// 					// let device = _.find(initDevices_list, ['device_id', item.device_id])
			// 					let device = _.find(initDevices_list, (dev) => dev.device_id.toString() === item.device_id.toString())
			// 					if (device) {
			// 						device.online = item.online || device.online
			// 						// device.online_gps   = item.online_gps || device.online_gps
			// 						// device.offline30sec = ( device.online_gps && device.infoData && moment(item.gps.timestamp).diff( moment(device.infoData.timestamp), 'seconds') > 30 )

			// 						mmm.push(device)

			// 						if (item.events && item.events.length) {
			// 							_alerts = _.union(_alerts, fillAlertsArray({ driver_name: device.driver_name, ...item }))
			// 						}
			// 					}

			// 					// FWSD-4032
			// 					if (
			// 						props.selectedTrip
			// 						&& props.selectedTrip.isLiveTrip
			// 						&& item.device_id.toString() === state.activeTreeItem.device_id.toString()
			// 						&& props.tripsGPS.length
			// 					) {
			// 						// Gets the last GPS point (props.tripsGPS[0].polygon) of the Live trip (props.selectedTrip)
			// 						const lastTripsGPSPoint = props.tripsGPS[0].polygon[props.tripsGPS[0].polygon.length - 1]


			// 						// If a trip ends (vehicle idles or goes in parking mode) during a live trip, show the Trip is Processing message
			// 						if (/*!item.online ||*/ !item.ignition.state) {
			// 							// console.log('!!!!!!!!!!! Trip IS Processing')
			// 							debugger
			// 							props.setSelectedTrip({ ...props.selectedTrip, isLiveTrip: false, isTripProcessing: true })

			// 							const newDeviceTrips = props.deviceTrips.map((devicetrip) => {
			// 								if (devicetrip.route_id === props.selectedTrip.route_id) {
			// 									devicetrip.isLiveTrip = false
			// 									devicetrip.isTripProcessing = true
			// 									devicetrip.end_gps = {
			// 										latitude: (item.gps.lan || lastTripsGPSPoint.lat) * 1,
			// 										longitude: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
			// 										timestamp: item.gps.timestamp,
			// 									}
			// 								}
			// 								return devicetrip
			// 							})
			// 							props.setDeviceTrips(newDeviceTrips)
			// 						}

			// 						// Generates the new last GPS point of the Live trip
			// 						const tripGPSNewPoint = {
			// 							lat: (item.gps.lan || lastTripsGPSPoint.lat) * 1,
			// 							lng: (item.gps.lon || lastTripsGPSPoint.lng) * 1,
			// 							speed: (item.gps.spd || lastTripsGPSPoint.speed) * 1,
			// 							timestamp: moment.utc(item.gps.timestamp).format('YYYY-MM-DD HH:mm:ss'),
			// 							dir: (item.gps.dir || lastTripsGPSPoint.dir) * 1,
			// 							key: ((item.ignition.state || lastTripsGPSPoint.key) * 1).toString(),
			// 							driver_id: lastTripsGPSPoint.driver_id,
			// 							driver_name: lastTripsGPSPoint.driver_name,
			// 							dst: (item.gps.dst || lastTripsGPSPoint.dst) * 1,
			// 						}

			// 						// Stores new last GPS point to the tripsGPS[0].polygon
			// 						props.addTripsGPSPolygonPoint(tripGPSNewPoint)

			// 						// Changes location of the marker on the map
			// 						const item2 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
			// 						// console.log('item2: ', item2)
			// 						if (item2) {
			// 							item2.entry.online = item.hasOwnProperty('online') ? item.online : item2.entry.online
			// 							if (item.gps) {
			// 								const newGPS = item.gps
			// 								if (_.has(newGPS, 'key')) {
			// 									item2.entry.ignition = { ...item2.entry.ignition, state: newGPS.key }
			// 								} else if (_.has(item.ignition, 'state')) {
			// 									item2.entry.ignition = { ...item2.entry.ignition, state: item.ignition.state }
			// 									newGPS.key = item.ignition.state
			// 								}
			// 								item2.icon_direction = getIconDirection(item2.icon_direction || 'e', item2.position, { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
			// 								item2.position = { lat: newGPS.lan * 1 || item2.position.lat, lng: newGPS.lon * 1 || item2.position.lng }
			// 								item2.infoData = Object.assign({}, item2.infoData, newGPS)
			// 								item2.ignitionСhange = Object.assign({}, item2.ignitionСhange, item.ignition)
			// 							}

			// 							// setState({ ...state, markers: [item2] })
			// 							setState((prevState) => { return { 
			// 								...prevState, 
			// 								markers: [item2]
			// 							} })
			// 						}
			// 					}
			// 				})

			// 				const devicestmp = _.uniqWith(_.union(initDevices_list, mmm), _.isEqual)
			// 				const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)

			// 				// setState({ ...state, initDevices: devicestmp, alerts: alertstmp })
			// 				setState((prevState) => { return { 
			// 					...prevState, 
			// 					initDevices: devicestmp, alerts: alertstmp
			// 				} })
			// 			}
			// 			else {
			// 				res.data.response.devices.map((item, i) => {
			// 					// Autoupdate online and ignition properties of the tree selected device
			// 					if (state.activeTreeItem && state.activeTreeItem.device_id === item.device_id) {
			// 						// setState({ ...state, activeTreeItem: { ...state.activeTreeItem, online: item.online, ignition: item.ignition } })
			// 						setState((prevState) => { return { 
			// 							...prevState, 
			// 							activeTreeItem: { ...state.activeTreeItem, online: item.online, ignition: item.ignition }
			// 						} })
			// 					}
			// 					// let item1 = _.find(markers_list, ['device_id', item.device_id])
			// 					let item1 = _.find(markers_list, (mark) => mark.device_id.toString() === item.device_id.toString())
			// 					if (item1) {
			// 						item1.entry.online = item.hasOwnProperty('online') ? item.online : item1.entry.online
			// 						// item1.entry.online_gps = item.hasOwnProperty('online_gps') ?  item.online_gps : item1.entry.online_gps
			// 						// item1.entry.offline30sec = false
			// 						if (item.gps) {
			// 							const newGPS = item.gps
			// 							if (_.has(newGPS, 'key')) {
			// 								item1.entry.ignition = { ...item1.entry.ignition, state: newGPS.key }
			// 							} else if (_.has(item.ignition, 'state')) {
			// 								item1.entry.ignition = { ...item1.entry.ignition, state: item.ignition.state }
			// 								newGPS.key = item.ignition.state
			// 							}
			// 							// item1.entry.offline30sec = ( item1.entry.online_gps && item1.infoData && moment(newGPS.timestamp).diff( moment(item1.infoData.timestamp), 'seconds') > 30 )
			// 							item1.icon_direction = getIconDirection(item1.icon_direction || 'e', item1.position, { lat: newGPS.lan * 1 || 0, lng: newGPS.lon * 1 || 0 }, newGPS.dir)
			// 							item1.position = { lat: newGPS.lan * 1 || item1.position.lat, lng: newGPS.lon * 1 || item1.position.lng }
			// 							item1.infoData = Object.assign({}, item1.infoData, newGPS)
			// 							item1.ignitionСhange = Object.assign({}, item1.ignitionСhange, item.ignition)
			// 						}
			// 					}

			// 					mmm = _.union(mmm, [].push(item1))

			// 					if (item.gps && item.gps.lan && item.gps.lon && state.centerDevice && (item.device_id == state.centerDevice.device_id)) {
			// 						followmap_position = { lat: item.gps.lan * 1, lng: item.gps.lon * 1 }
			// 					};
			// 					if (item.events && item.events.length) {
			// 						_alerts = _.union(_alerts, fillAlertsArray({ driver_name: item1.driver_name, ...item }))
			// 					}
			// 				})
			// 				const markerstmp = _.uniqWith(_.union(markers_list, mmm), _.isEqual)
			// 				const alertstmp = _.uniqWith(_.union(state.alerts, _alerts), _.isEqual)
			// 				let _state = {
			// 					markers: markerstmp,
			// 					alerts: alertstmp
			// 				}
			// 				if (followmap_position) {
			// 					_state['center'] = { lat: followmap_position.lat, lng: followmap_position.lng }

			// 					setTimeout(() => { google.maps.event.trigger(_map.current.context[MAP], 'resize'); }, 1000)
			// 				}

			// 				// setState({ ...state, ..._state })
			// 				setState((prevState) => { return { 
			// 					...prevState, 
			// 					..._state
			// 				} })
			// 			}//* END if (state.showTripPanel)
			// 		})
			// 		.catch((error) => {
			// 			console.log('!getDevicesEventUpdates error: ', error.response, error)
			// 		})

			// }, 50000000))
		}
	}

	const onZoomChangedManually = (e, p) => {
		const zoom = _map.current.getZoom()
		// setState({ ...state, zoom })
		setState((prevState) => { return { ...prevState, zoom } })
	}

	const onMaptypeChangedManually = () => {
		// setState({ ...state, maptype: _map.current.getMapTypeId() })
		setState((prevState) => { return { ...prevState, maptype: _map.current.getMapTypeId() } })
	}

	const onClickAddress = (device_id) => {
		const { markers } = state
		const marker = _.find(markers, ['device_id', device_id])
		const { lat, lng } = marker.position
		marker.infoData.address = 'Loading'
		// setState({ ...state, markers })
		setState((prevState) => { return { ...prevState, markers } })

		getDeviceAddress({ lat, lng })
			.then((res) => {
				let address = formatAddress(res.data.response.address)
				marker.infoData.address = address || 'Not Available'
				// setState({ ...state, markers })
				setState((prevState) => { return { ...prevState, markers } })
			})
			.catch(err => {
				console.log(err)
			})
	}

	const onSelectMarker = (device_id) => {
		// debugger
		ReactGA.event({
			category: userRole,
			action: 'Select Device',
			label: 'Map Item Select'
		})
		const { activeTreeItem } = state
		let markerEntry = null
		let selectedDevice
		const markers = state.markers.map((item) => {
			if (item.device_id === device_id) {
				selectedDevice = item
				markerEntry = item.entry
			} else {
				item.showInfoWindow = false
			}

			return item
		})

		if (selectedDevice) {
			if (activeTreeItem && device_id === activeTreeItem.device_id) {
				selectedDevice.showInfoWindow = false
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}

				// setState({ ...state, showVehicleSidebar: false, activeTreeItem: null })
				setState((prevState) => { return { 
					...prevState,
					showVehicleSidebar: false,
					activeTreeItem: null
				} })
			} else {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				const group_name = state.initDevices.find(device => device.device_id === device_id).group_name
				const collapsedBookkeeping = state.groups.map(el => el.id === group_name ? false : true);

				zoomToVehicle(15, markerEntry)
				// setState({ ...state, showVehicleSidebar: true, activeTreeItem: markerEntry, collapsedBookkeeping })
				setState((prevState) => { return { 
					...prevState,
					showVehicleSidebar: true,
					activeTreeItem: markerEntry,
					collapsedBookkeeping 
				} })
			}
		} else {
			setMarkersBound()
		}

		// setState({ ...state, markers })
		setState((prevState) => { return { 
			...prevState,
			markers
		} })
	}

	const handleTreeClick = (i) => {
		let [...collapsedBookkeeping] = state.collapsedBookkeeping;
		collapsedBookkeeping[i] = !collapsedBookkeeping[i];
		// setState({ ...state, collapsedBookkeeping: collapsedBookkeeping });
		setState((prevState) => { return { 
			...prevState,
			collapsedBookkeeping
		} })
	}

	const onTreeDeviceClick = (entry) => {
		// debugger
		ReactGA.event({
			category: userRole,
			action: 'Select Device',
			label: 'Menu Dropdown'
		})
		setShowTripsHistory(false)
		const markers = [...state.markers];
		const selectedDevice = markers.find(vehicle => vehicle.device_id === entry.device_id);
		const { activeTreeItem } = state;
		if (selectedDevice) {
			// DEVICE ALREADY ACTIVE
			if (activeTreeItem && selectedDevice.device_id === activeTreeItem.device_id) {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				// setState({ ...state, showVehicleSidebar: false, activeTreeItem: null })
				setState((prevState) => {
					return {
						...prevState,
						showVehicleSidebar: false,
						activeTreeItem: null
					}
				})
			} else {
				if (selectedDevice.infoData) {
					selectedDevice.infoData.address = ''
				}
				if (selectedDevice.position.lat !== 0) {
					zoomToVehicle(15, entry)
					// setState({ ...state, showVehicleSidebar: true })
					setState((prevState) => {
						return {
							...prevState,
							showVehicleSidebar: true
						}
					})
				}
				else {
					// setState({ ...state, showVehicleSidebar: true })
					setState((prevState) => {
						return {
							...prevState,
							showVehicleSidebar: true
						}
					})
					toastr.info('Vehicle GPS Unavailable');
				}
				// setState({ ...state, markers, activeTreeItem: entry });
				setState((prevState) => {
					return {
						...prevState,
						markers,
						activeTreeItem: entry
					}
				})
			}
		} else {
			setMarkersBound()
			// setState({ ...state, activeTreeItem: entry });
			setState((prevState) => {
				return {
					...prevState,
					activeTreeItem: entry
				}
			})
		}

		// setState({ ...state, markers });
		setState((prevState) => {
			return {
				...prevState,
				markers
			}
		})
	}

	const onChangeVehicleSearch = (search_value, search_category = null) => {
		const value = search_value.toLowerCase()
		const category = (search_category || state.category) * 1
		if (value == '') {
			let result = [];
			const devices = state.initDevices;
			const groups = _.groupBy(devices, function (device) { return device.group_name; });
			let keys = Object.keys(groups);
			keys = _.sortBy(keys, function (num) { return num.toLowerCase(); });

			for (var i = 0; i < keys.length; i++) {
				var k = keys[i];
				result.push({ 'id': k, 'value': groups[k] });
			}

			// setState({ ...state, autoValue: value, activeTreeItem: null, groups: result, collapsedBookkeeping: result.map(() => true) });
			setState((prevState) => { return { ...prevState, autoValue: value, activeTreeItem: null, groups: result, collapsedBookkeeping: result.map(() => true) } })
		} else {
			let result = [];
			let devices = [];

			switch (category) {
				case 1:
					devices = state.initDevices.filter((device) => ((device.group_name ? device.group_name + ' - ' : '') + (device.vehicle_name ? device.vehicle_name + ' - ' : '') + device.device_id).toLowerCase().indexOf(value) !== -1);
					break
				case 2:
					devices = state.initDevices.filter((device) => device.device_id.toString().toLowerCase().indexOf(value) !== -1);
					break
				case 3:
					devices = state.initDevices.filter((device) => (device.vehicle_name && device.vehicle_name.toLowerCase().indexOf(value) !== -1));
					break
				case 4:
					devices = state.initDevices.filter((device) => (device.group_name && device.group_name.toLowerCase().indexOf(value) !== -1));
					break
				default:
					break
			}

			const groups = _.groupBy(devices, function (device) { return device.group_name; });
			let keys = Object.keys(groups);
			keys = _.sortBy(keys, function (num) { return num.toLowerCase(); });

			for (var i = 0; i < keys.length; i++) {
				var k = keys[i];
				result.push({ 'id': k, 'value': groups[k] });
			}
			// setState({ ...state, autoValue: value, activeTreeItem: null, groups: result, collapsedBookkeeping: result.map(() => false) });
			setState((prevState) => { return { ...prevState, autoValue: value, activeTreeItem: null, groups: result, collapsedBookkeeping: result.map(() => false) } })
		}
	}

	const liveVideoUserAccess = () => {
		const { user } = props
		const userPermission = user.user.company_data

		if (!userPermission.live_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
			return false
		}
		else {
			return true
		}
	}

	const traceUserAccess = () => {
		const { user } = props
		const companyPermissions = user.user.company_data

		if (!companyPermissions.trace_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
			// setState({ ...state, company_trace_active: false })
			setState((prevState) => {
				return {
					...prevState,
					company_trace_active: false
				}
			});
		}
		else {
			// setState({ ...state, company_trace_active: true })
			setState((prevState) => {
				return {
					...prevState,
					company_trace_active: true
				}
			});
		}
	}

	const zoomToVehicle = (zoomSize, entry) => {
		const { activeTreeItem, markers } = state
		if (!entry && !activeTreeItem) {
			toastr.warning('', 'Please select a vehicle to zoom to');
			return;
		}

		const activeDeviceId = (entry || activeTreeItem).device_id;
		const activemarker = markers.filter(marker => marker.device_id == activeDeviceId && marker.visible_icon);

		if (activemarker.length) {
			// setState({ ...state, zoom: zoomSize, center: activemarker[0].position });
			setState((prevState) => { return { ...prevState, zoom: zoomSize, center: activemarker[0].position } })
		}
	}

	// const openLive = (event, device_id) => {
	// 	console.log('openLive', event, device_id)
	// 	event.preventDefault();

	// 	const width = 660, height = 400,
	// 		w = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0],
	// 		winWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	// 		winHeight = w.innerHeight || e.clientHeight || g.clientHeight,
	// 		winX = (document.all) ? window.screenLeft : window.screenX,
	// 		winY = (document.all) ? window.screenTop : window.screenY,
	// 		left = ((winWidth - width) / 2) + winX,
	// 		top = ((winHeight - height) / 2) + winY,
	// 		windowSpecs = 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=1,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top,
	// 		target = device_id;

	// 	return window.open('/live/video/' + target, target + '1', windowSpecs);
	// }

	const openClip = (event, eventId) => {
		event.preventDefault();

		const { user, company } = props
		const winOpen = {
			eventId: eventId,
			userRole: user.user.roles[0],
			companyName: company.company.name,
			partnerName: company.company.partner,
			driverRecognition: company.company.driver_recognition,
		}
		localStorage.setItem('winOpen', JSON.stringify(winOpen));

		ReactGA.event({
			category: userRole,
			action: 'Alert Popup',
			label: 'Open Alert Popup Clip'
		})

		const width = 1200
		const height = 800
		const w = window
		const d = document
		const e = d.documentElement
		const g = d.getElementsByTagName('body')[0]
		const winWidth = w.innerWidth || e.clientWidth || g.clientWidth
		const winHeight = w.innerHeight || e.clientHeight || g.clientHeight
		const winX = (document.all) ? window.screenLeft : window.screenX
		const winY = (document.all) ? window.screenTop : window.screenY
		const left = ((winWidth - width) / 2) + winX
		const top = ((winHeight - height) / 2) + winY
		const windowSpecs = 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=1,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top
		const target = eventId
		const win = window.open('/event/video/' + target, target + '1', windowSpecs);

		return win
	}

	const clearSingleTrucks = () => {
		let markers = state.markers.map((item, i) => {
			item.entry.single_truck = false;
			return item;
		});
		setState({ ...state, singleTrucks: [], markers: markers });
	}

	const handleSplitBarMouseDown = (e) => {
		e.preventDefault();

		document.addEventListener('mousemove', splitBlocks);
		document.addEventListener('mouseup', documentMouseUp);
	}

	const handleBarToggleMouseDown = (e) => {
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		hideDevicesTree(e)
	}

	const hideDevicesTree = (e) => {
		if ($('#block-tree').width() < 13) {
			$('#block-tree').css("width", 300).css("left", 0);
			$('#map-block').css("left", 300);
		}
		else {
			$('#block-tree').css("width", 12).css("left", 0);
			$('#map-block').css("left", 12);
		}

		setMapCenter();
	}

	// const startTripReplay = () => {
	// 	if (!state.activeTreeItem) {
	// 		toastr.warning('', 'Please select a vehicle to playback');
	// 		return;
	// 	}
	// 	setState({...state,  additionalClassName: 'tripReplayPanelOpened', /*redrawTimeline: true,*/ /*markers: []*/ });
	// 	//*********************************************

	// 	const active_device = state.activeTreeItem

	// 	active_device.start_playback = !active_device.start_playback
	// 	setState({...state,  
	// 		showTripPanel: true,
	// 		activeTreeItem: active_device,
	// 	});

	// 	if (active_device.start_playback == false) {
	// 		let nextDevices = state.alertdevices.filter(device => device.device_id != active_device.device_id);
	// 		let nextGroups  = state.alertshistory.groups.filter(group => group.device_id != active_device.device_id);
	// 		let nextItems   = state.alertshistory.items.filter(item => item.device_id != active_device.device_id);

	// 		let _alertshistory = state.alertshistory;
	// 		_alertshistory.groups = nextGroups;
	// 		_alertshistory.items = nextItems;

	// 		if (state.polygonDevice == active_device.device_id) {
	// 			setState({...state,  polygons: [] });
	// 		}

	// 		if (nextDevices.length > 0) {
	// 			setState({...state,  alertdevices: nextDevices, alertshistory: _alertshistory/*, redrawTimeline: true*/ });
	// 		}
	// 		else {
	// 			closeTimeline();
	// 		}
	// 	} else {
	// 		setState({...state,  maptype: 'roadmap'});

	// 		let _alertdevices = state.alertdevices;
	// 		_alertdevices.push({ 
	// 			name: active_device.vehicle_name,
	// 			device_id: active_device.device_id,
	// 			entry: active_device,
	// 		});

	// 		setState({...state,  alertdevices: _alertdevices });

	// 		const data = {
	// 			device_ids: _alertdevices.map((item,i) => item.device_id).join(','), 
	// 			start_ts: moment(state.currentTimelineDateData).utc().subtract(12, 'hours').format('YYYYMMDDHHmmss'), 
	// 			end_ts: moment(state.currentTimelineDateData).utc().add(12, 'hours').format('YYYYMMDDHHmmss'),
	// 		}

	// 		let getlastknown = true;
	// 		if (_alertdevices.length !== 1 /*|| (state.location && state.location.type === 'redirectFromUnknownDrivers')*/) {
	// 			getlastknown = false;
	// 		}
	// 		getDevicesMetadataForTrip(
	// 			data, 
	// 			function(){  
	// 				if (_alertdevices.length == 1) {
	// 					setState({...state, showTripPanel: true, tripHeight: 240 /*, redrawTimeline: true */});
	// 						function(){
	// 							$('.vis-timeline .vehicle-parent button').click();
	// 						}
	// 					setState({...state, additionalClassName: 'tripReplayPanelOpened'});                            
	// 				}
	// 				else {
	// 					setState({...state, showTripPanel: true, moveTo: state.currentTimelineDateData /* , redrawTimeline: true */ });
	// 				}
	// 			},
	// 			getlastknown
	// 		)
	// 	}
	// }

	const viewEventClip = (e, row) => {
		e.preventDefault();

		//* When sent to storage page from Trip Replay panel, there should be a return tab: https://roscolive.atlassian.net/browse/FWSD-639
		let states = null;
		if (!props.donotuseredux) {
			states = { ...state };
			states.redrawTimeline = true;
			states.popover = {
				show: false,
				left: 0,
				top: 0,
				type: '',
				content: '',
				event: {
					event_type: '',
					event_device_id: 0,
					event_id: 0,
					event_ts: ''
				}
			}
		}
		//* Delete states.alerts;
		props.updateTripreplay(states);

		browserHistory.push({
			pathname: "/event",
			state: {
				event_device_id: row.event_device_id,
				event_id: row.event_id,
				event_ts: row.event_ts,
				type: 'trip'
			}
		});
	}

	const requestCustomAlertVideo = (e, row) => {
		e.preventDefault()

		console.log('requestCustomAlertVideo request', row);

		toggleLoader(true);

		const data = {
			device_id: row.event_device_id,
			timestamp: row.event_ts,
			alert_type: row.event_type
		}
		requestCustomAlertVideo(data)
			.then((res, err) => {
				console.log('requestCustomAlertVideo res', res);

				if (res.data.response.request_id) {
					$(row.img_link).attr('data-event_id', res.data.response.request_id);

					let popover = state.popover;
					popover.event.event_id = res.data.response.request_id;
					// setState({ ...state, popover });
					setState((prevState) => { return { ...prevState, popover } })
				}
				toggleLoader(false);

				toastr.success('', 'Custom Video Requested');
			})
			.catch((error) => {
				toggleLoader(false);

				console.log('requestCustomAlertVideo error');
				console.log(error);

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const handleIdentifyDriverClick = (e, event) => {
		e.preventDefault()

		browserHistory.push({
			pathname: "/managedrivers",
			state: {
				event,
				type: 'redirectFromTripReplay'
			}
		});
	}

	const getDevicesMetadataForTrip = (data, callback, getlastknown = false) => {
		toggleLoader(true);

		/* If the vehicle is offline it won't have any replay data at the current time. Instead, we should load and display the last known GPS location. */
		let action = getDevicesMetadataAction;
		if (getlastknown) {
			action = getDevicesMetadataLastKnown;
		}
		action(data)
			.then((res, err) => {
				console.log('!getDevicesMetadataAction/getDevicesMetadataLastKnown res: ', res, err);

				let items = []
				let groups = []
				let lastknowntimestamp = '1970-01-01 00:00:00'
				let k = 0
				const vehicles = _.orderBy(res.data.response, ['vehicle_name', 'device_id'], ['asc', 'asc']);

				vehicles.map((vehicle, i) => {
					let polygons = []
					let polygon = []
					let curgroups = []

					let starttimestamp = null
					let endtimestamp = null
					let curtimestamp = null

					let localtimestamp = null
					let start_ts = null
					let end_ts = null

					vehicle.metadata.map((item, j) => {
						if (item.type === 'Gps') {
							localtimestamp = moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss');
							if (localtimestamp > lastknowntimestamp) {
								lastknowntimestamp = localtimestamp;
							}

							if (!curtimestamp) {
								curtimestamp = localtimestamp; //item.timestamp;
								starttimestamp = localtimestamp; //item.timestamp;
							} else {
								if (moment(item.timestamp).diff(moment(curtimestamp), 'minutes') > 1 && polygon.length > 0) {
									polygons.push({ polygon: polygon, starttimestamp: starttimestamp, endtimestamp: curtimestamp });
									items.push({ group: '' + i, start: moment(starttimestamp), end: moment(curtimestamp), device_id: vehicle.device_id });
									starttimestamp = localtimestamp; //item.timestamp;
									polygon = [];
								}

								curtimestamp = localtimestamp;
							}

							polygon.push({
								"lat": item.latitude,
								"lng": item.longitude,
								speed: item.speed,
								timestamp: localtimestamp,
								dir: item.dir,
								key: item.key,
							});
						} else {
							start_ts = (item.start_ts) ? moment(item.start_ts + '+00').format('YYYY-MM-DD HH:mm:ss') : '';
							end_ts = (item.end_ts) ? moment(item.end_ts + '+00').format('YYYY-MM-DD HH:mm:ss') : '';

							if ((end_ts || start_ts || '1970-01-01 00:00:00') > lastknowntimestamp) {
								lastknowntimestamp = end_ts;
							}

							let img5 = document.createElement('img');
							img5.src = '/images/alert.png';
							img5.style.width = '24px';
							img5.style.height = '24px';
							img5.style.cursor = 'pointer';
							img5.setAttribute('data-event_id', (item.event_id || ''));
							img5.className = `${item.type.toLowerCase()}_${moment(item.start_ts).format('YYYYMMDDHHmmss')}`


							img5.addEventListener('click', function (e) {
								if (typeof e.stopPropagation == "function") {
									e.stopPropagation();
								} else {
									e.cancelBubble = true;
								}
								const content = 'Start alert: ' + ((item.start_ts) ? moment(item.start_ts + '+00').format('YYYY-MM-DD HH:mm:ss') : '') + '<br>End alert: ' + ((item.end_ts) ? moment(item.end_ts + '+00').format('YYYY-MM-DD HH:mm:ss') : '');


								const sideMenu = document.querySelector('.sideMenu')
								const popover = {
									show: true,
									left: e.pageX - e.offsetX - sideMenu.offsetWidth - 25,
									top: e.pageY - e.offsetY - 108,
									type: ((item.type == 'InputSensor' && item.event_id) ? 'DriverEvent' : item.type) + ' (' + (vehicle.vehicle_name || vehicle.device_id) + ')',
									content: content,
									event: {
										img_link: this,
										event_type: item.type,
										event_device_id: vehicle.device_id,
										event_id: $(this).attr('data-event_id') || '',//item.event_id, //7419
										event_ts: item.start_ts || item.end_ts, //"2018-02-18 19:39:40",
									}
								}

								// setState({ ...state, popover /*, redrawTimeline: false*/ });
								setState((prevState) => { return { ...prevState, popover } })
							});


							if (item.type === 'GSensor') {
								let groupId = i + 'GSensor'
								items.push({ group: groupId, start: moment(start_ts), end: moment(end_ts || start_ts), device_id: vehicle.device_id, content: img5 /*, id: 1*/ });

								if (!curgroups.find(o => o.id === groupId))
									curgroups.push({ id: groupId, content: 'GSensor', type: 'node', device_id: vehicle.device_id });
							} else if (item.type === 'HighSpeed') {
								let groupId = i + 'HighSpeed';
								items.push({ group: groupId, start: moment(start_ts), end: moment(end_ts || start_ts), device_id: vehicle.device_id, content: img5 /*, id: 1*/ });

								if (!curgroups.find(o => o.id === groupId))
									curgroups.push({ id: groupId, content: 'HighSpeed', type: 'node', device_id: vehicle.device_id });
							} else if (item.type === 'InputSensor') {
								let groupId = i + 'InputSensor';
								items.push({ group: groupId, start: moment(start_ts), end: moment(end_ts || start_ts), device_id: vehicle.device_id, content: img5 /*, id: 1*/ });

								if (!curgroups.find(o => o.id === groupId))
									curgroups.push({ id: groupId, content: 'Driver', type: 'node', device_id: vehicle.device_id });
							} else if (item.type === 'FatalGSensor') {
								let groupId = i + 'FatalGSensor';
								items.push({ group: groupId, start: moment(start_ts), end: moment(end_ts || start_ts), device_id: vehicle.device_id, content: img5 /*, id: 1*/ });

								if (!curgroups.find(o => o.id === groupId))
									curgroups.push({ id: groupId, content: 'CriticalGSensor', type: 'node', device_id: vehicle.device_id });
							} else if (item.type === 'UnknownDriver') {
								const groupId = i + 'UnknownDriver';
								items.push({ group: groupId, start: moment(start_ts), end: moment(end_ts || start_ts), device_id: vehicle.device_id, content: img5 /*, id: 1*/ });

								if (!curgroups.find(o => o.id === groupId))
									curgroups.push({ id: groupId, content: 'UnknownDriver', type: 'node', device_id: vehicle.device_id });
							}

						}
					})

					if (polygon.length > 0) {
						polygons.push({ polygon: polygon, starttimestamp: starttimestamp, endtimestamp: curtimestamp });
						items.push({ group: '' + i, start: moment(starttimestamp), end: moment(curtimestamp), device_id: vehicle.device_id });
					}

					const device = state.alertdevices.filter(device => device.device_id == vehicle.device_id)
					const device_entry = (device.length) ? device[0].entry : {}


					let c = i;
					if (i > 9) c = 0;
					if (curgroups.length > 0) {
						groups.push({
							order: k++,
							id: '' + i,
							device_id: vehicle.device_id,
							polygons: polygons,
							content: vehicle.vehicle_name || vehicle.device_id,
							type: 'parent',
							entry: device_entry,
							className: 'parent col' + c,
							driver_name: vehicle.driver_name,
							driver_trips: vehicle.driver_trips,
						});
						curgroups.map((group, j) => {
							group.order = k++;
							group.className = 'node col' + c;
							groups.push(group);
						});
					} else {
						groups.push({
							order: k++,
							id: '' + i,
							device_id: vehicle.device_id,
							polygons: polygons,
							content: vehicle.vehicle_name || vehicle.device_id,
							type: 'parent',
							entry: device_entry,
							className: 'parent col' + c,
							driver_name: vehicle.driver_name,
							driver_trips: vehicle.driver_trips,
						});
					}
				});

				console.log('!!!groups: ', groups);

				let _alertshistory = state.alertshistory;
				_alertshistory.items = items;
				_alertshistory.groups = groups;

				if (getlastknown) {
					console.log('lastknowntimestamp', lastknowntimestamp);
					if (lastknowntimestamp == '1970-01-01 00:00:00') {
						lastknowntimestamp = moment().format('YYYY-MM-DD HH:mm:ss');
					}
					// setState({
					// 	...state,
					// 	currentTimelineDateData: lastknowntimestamp,
					// 	currentTimelineDate: moment(lastknowntimestamp),
					// 	moveTo: lastknowntimestamp,
					// 	alertshistory: _alertshistory
					// })
					setState((prevState) => { return { 
						...prevState,
						currentTimelineDateData: lastknowntimestamp,
						currentTimelineDate: moment(lastknowntimestamp),
						moveTo: lastknowntimestamp,
						alertshistory: _alertshistory 
					} })
				} else {
					// setState({ ...state, alertshistory: _alertshistory });
					setState((prevState) => { return { ...prevState, alertshistory: _alertshistory } })
				}
				console.log('!!!alertshistory: ', _alertshistory)

				if (callback && typeof callback === "function") {
					callback();
				}

				toggleLoader(false);
			})
			.catch((error) => {
				toggleLoader(false);
				console.log(error);

				let errDescription = 'An unexpected error occurred. Please try again later'
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const onClickPlayback = (current) => {
		const { tripsGPS } = props

		if (!moment.isMoment(current)) {
			current = moment(current.time)
		}

		if (tripsGPS.length && tripsGPS[0].polygon.length) {
			const pos = _.find(tripsGPS[0].polygon, (item) => {
				return moment(item.timestamp) >= current;
			});

			if (pos) {
				const position = { lat: pos.lat, lng: pos.lng };
				const { markers } = state

				markers[0].icon_name = markers[0].entry.vehicle_icon;
				markers[0].icon_direction = getIconDirection(markers[0].icon_direction, markers[0].position, position, pos.dir);
				markers[0].position = position;
				markers[0].infoData = Object.assign({}, markers[0].infoData, pos);
				markers[0].visible_icon = true;

				// setState({ ...state, markers });
				setState((prevState) => {
					return {
						...prevState,
						markers
					}
				})
			} else {
				const { markers } = state

				if (markers.length) {
					markers[0].visible_icon = false;
				}

				// setState({ ...state, markers });
				setState((prevState) => {
					return {
						...prevState,
						markers
					}
				})
			}
		} else {
			const { markers } = state

			if (markers.length) {
				markers[0].visible_icon = false;
			}

			// setState({ ...state, markers });
			setState((prevState) => {
				return {
					...prevState,
					markers
				}
			})
		}
	}

	const openAdvancedPlayer = (event) => {
		// setState({ ...state, showAdvancedPlayer: true, selectedEvent: event })
		setState((prevState) => { return { ...prevState, showAdvancedPlayer: true, selectedEvent: event } })
	}

	const closePopover = (e) => {
		e.preventDefault()

		const popover = {
			show: false,
			left: 0,
			top: 0,
			type: '',
			content: '',
			event: {
				event_type: '',
				event_device_id: 0,
				event_id: 0,
				event_ts: ''
			}
		}

		// setState({ ...state, popover: popover });
		setState((prevState) => { return { ...prevState, popover } })
	}

	const closeTimeline = () => {
		state.alertdevices.map((item, i) => item.entry.start_playback = false);
		// setState({ ...state, alertdevices: state.alertdevices });
		setState((prevState) => { return { ...prevState, alertdevices: state.alertdevices } })

		// setState({
		// 	...state,
		// 	alertdevices: [],
		// 	alertshistory: [],
		// 	showTripPanel: false,
		// 	markers: [],
		// 	polygons: [],
		// 	maptype: 'roadmap', //'hybrid',
		// 	tripHeight: -14,
		// 	additionalClassName: 'tripReplayPanelClosed',
		// });
		setState((prevState) => { return { 
			...prevState, 
			alertdevices: [],
			alertshistory: [],
			showTripPanel: false,
			markers: [],
			polygons: [],
			maptype: 'roadmap', //'hybrid',
			tripHeight: -14,
			additionalClassName: 'tripReplayPanelClosed',
		} })

		if (_map?.current) {
			google.maps.event.trigger(_map.current.context[MAP], 'resize');
		}

		//* Start setInterval
		let _markers = [];
		state.initDevices.map((item, i) => {
			//* Fills the markes array
			let name = item.vehicle_name || item.device_id;
			_markers.push({
				position: { lat: 0, lng: 0 },
				icon_name: item.vehicle_icon,
				icon_direction: 'e',
				active: false,
				name: name,
				device_id: item.device_id,
				entry: item,
				showInfoWindow: false,
				infoData: null,
				ignitionСhange: null,
				visible_icon: false
			});

			item.start_tracking = true;
			item.online = false;
			// item.online_gps = false;
			return item;
		});

		// setState({ ...state, markers: _markers });
		setState((prevState) => { return { ...prevState, markers: _markers } })
		getDevicesMetadataOnline(_markers);
	}

	const onClickLiveTraffic = () => {
		const { showLiveTraffic } = state
		// setState({ ...state, showLiveTraffic: !showLiveTraffic })
		setState((prevState) => { return { ...prevState, showLiveTraffic: !showLiveTraffic } })
	}

	const handleVehicleSidebarToggle = () => {
		const { showVehicleSidebar } = state
		// setState({ ...state, showVehicleSidebar: !showVehicleSidebar })
		setState((prevState) => { return { ...prevState, showVehicleSidebar: !showVehicleSidebar } })
	}

	const onCloseEventVideoAll = () => {
		const { setTripAdvancedPlayerEvent } = props
		setTripAdvancedPlayerEvent(null)
		// setState({ ...state, showAdvancedPlayer: false, selectedEvent: null })
		setState((prevState) => { return { ...prevState, showAdvancedPlayer: false, selectedEvent: null } })
	}

	const onCloseShareEvent = () => {
		const { setTripShowShareEvent } = props
		setTripShowShareEvent(null)
		// setState({ ...state, showShareEvent: false })
		setState((prevState) => { return { ...prevState, showShareEvent: false } })
	}

	const openShareEvent = (event) => {
		// setState({ ...state, showShareEvent: true, selectedEvent: event })
		setState((prevState) => { return { ...prevState, showShareEvent: true, selectedEvent: event } })
	}

	const onFlagEvent = (row) => {
		const { id, flagged } = row

		toggleLoader(true);
		if (!flagged) {
			apiCall('PUT', '/events/{id}/flagged', { id })
				.then((res, err) => {
					if (!_.isEmpty(props.tripAdvancedPlayerEvent)) {
						let selectedEvent = props.tripAdvancedPlayerEvent;
						selectedEvent.flagged = true;
						props.setTripAdvancedPlayerEvent(selectedEvent)
					}
					else {
						row.flagged = true
					}
					toggleLoader(false);
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onFlagEvent put error:', error.response, error)

					let errDescription = 'An unexpected error occurred. Please try again later'
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
		else {
			apiCall('DELETE', '/events/{id}/flagged', { id })
				.then((res, err) => {
					if (!_.isEmpty(props.tripAdvancedPlayerEvent)) {
						let selectedEvent = props.tripAdvancedPlayerEvent;
						selectedEvent.flagged = false;
						props.setTripAdvancedPlayerEvent(selectedEvent)
					}
					else {
						row.flagged = false
					}
					toggleLoader(false);
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!onFlagEvent delete error:', error.response, error)

					let errDescription = 'An unexpected error occurred. Please try again later'
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
	}

	const updateDriver = (event_id, driver) => {
		const updatedEvents = [...state.alerts];
		 updatedEvents.map(event => {
			if (event.id === event_id) {
				event.driver_name = driver.first_name + ' ' + driver.last_name
				event.driver_id = driver.id
				setState((prevState) => { return { ...prevState, selectedEvent: event } })
			}
		})
		setState((prevState) => { return { ...prevState, alerts: updatedEvents } })
	}

	const openEventNote = () => {
		// setState({ ...state, showEventNote: true })
		setState((prevState) => { return { ...prevState, showEventNote: true } })
	}

	const onSaveEventNote = (note) => {
		if ((note && note.length) || note === '') {
			if (state.selectedEvent) {
				let selectedEvent = state.selectedEvent;
				selectedEvent.custom_event_type = note;
				// setState({ ...state, selectedEvent, showEventNote: false })
				setState((prevState) => { return { ...prevState, selectedEvent, showEventNote: false } })
			}
			else if (props.tripAdvancedPlayerEvent) {
				let selectedEvent = props.tripAdvancedPlayerEvent;
				selectedEvent.custom_event_type = note;
				props.setTripAdvancedPlayerEvent(selectedEvent)
				// setState({ ...state, showEventNote: false })
				setState((prevState) => { return { ...prevState, showEventNote: false } })
			}
		}
	}

	// FWSD-879
	const onClickSnapRoad = () => {
		const { tripsGPS, setTripsGPSSnapRoad, showSnapRoad, setShowSnapRoad } = props

		// // if user clicks on Snap Road button on the map and request of SnapRoads was done earlier then will not request again
		// if (showSnapRoad === false && tripsGPSSnapRoad.length) {
		// 	setShowSnapRoad(!showSnapRoad)
		// 	return
		// }
		if (showSnapRoad === true) {
			setShowSnapRoad(!showSnapRoad)
			return
		} else {
			setShowSnapRoad(!showSnapRoad)
		}

		if (tripsGPS.length) {
			const GOOGLE_API_KEY = 'AIzaSyCFXM5RPCbe9LzECG88fq9GtKcvnY-ZaDU'
			// const GOOGLE_API_KEY = 'AIzaSyB1aj2I6ZjWPg_79TOrFOWnNJJWLAu77io'
			const snapRoadGPS = []
			tripsGPS.forEach((trip) => {
				const tripGPS = trip.polygon
				const requestArray = []
				let pathValues = []
				let lastDst = 0
				tripGPS.forEach(({ lat, lng, dst }, i) => {
					if (i === 0) {
						lastDst = dst
						pathValues.push(`${lat},${lng}`)
						return
					}

					// filter of points: 
					// 1. coordinates next point should differ from previous
					// 2. distance between points shuld be more 100 meters
					// 3. if next distance less prevous then take this point					
					if (
						(tripGPS[i - 1].lat === lat && tripGPS[i - 1].lng === lng)
						|| (tripGPS[i - 1].dst > lastDst && tripGPS[i - 1].dst - lastDst < 100)
					) {
						return
					}

					lastDst = dst
					pathValues.push(`${lat},${lng}`)
					// google span to roads allows just 100 points per request
					if (pathValues.length === 100) {
						// console.log('pathValues: ', pathValues)
						requestArray.push(axios.get(`https://roads.googleapis.com/v1/snapToRoads?path=${pathValues.join('|')}&interpolate=true&key=${GOOGLE_API_KEY}`))
						pathValues = []
					}
				})
				if (pathValues.length) {
					// console.log('pathValues: ', pathValues)
					requestArray.push(axios.get(`https://roads.googleapis.com/v1/snapToRoads?path=${pathValues.join('|')}&interpolate=true&key=${GOOGLE_API_KEY}`))
				}

				if (requestArray.length) {
					toggleLoader(true);
					Promise.all(requestArray)
						.then(res => {
							console.log('Promise.all res: ', res)
							const snapCoords = []
							res.forEach((snap) => {
								snap.data.snappedPoints.forEach((point) => {
									snapCoords.push({
										lat: point.location.latitude,
										lng: point.location.longitude,
									})
								})
							})
							// console.log('snapCoords: ', snapCoords)
							setTripsGPSSnapRoad([
								{
									polygon: snapCoords,
									starttimestamp: trip.starttimestamp,
									endtimestamp: trip.endtimestamp,
								}
							])

							toggleLoader(false);
						})
						.catch(error => {
							toggleLoader(false);
							console.log('Promise.all error: ', error.response, error)
							toastr.error('Get Snap Road error occurred. Please try again later')
						},
						)

				}
			})
		}
	}

	// FWSD-4405
	const getDashboardRedirect = (argMarkers) => {
		const { dashboardRedirect } = props
		const varMarkers = argMarkers || state.markers
		
		if (dashboardRedirect && dashboardRedirect.type) {
			switch (dashboardRedirect.type) {
				case 'redirectFromDailyEvents':
				case 'redirectFromUnknownDrivers':
					const obj = _.find(varMarkers, ['device_id', dashboardRedirect.device_id.toString()])
					if (obj) {
						setShowTripsHistory(true)
						// setState({ ...state, activeTreeItem: obj.entry, showVehicleSidebar: true })
						setState((prevState) => { return { ...prevState, activeTreeItem: obj.entry, showVehicleSidebar: true } })
						// onTreeDeviceClick(obj.entry)
						// setShowTripsHistory(true)
					}
					break;
				default:
					break;
			}
		}
	}

	const { activeTreeItem, centerDevice, initDevices, showVehicleSidebar, showTripPanel, showEventVideoAll } = state;

	if (!user) {
		return (<div></div>)
	}

	const collapsedBookkeeping = state.collapsedBookkeeping;

	const sortFunc = (values) => {
		if (navigator && navigator.userAgent.search("Firefox") > -1) {
			return _.orderBy(values, ['online', 'vehicle_name', 'device_id'], ['desc', 'asc', 'asc']).sort((a, b) => (((a.online && a.online.state) && (b.online && b.online.state)) && ((a.ignition && a.ignition.state) < (b.ignition && b.ignition.state))) ? 1 : -1);
		}
		return _.orderBy(values, ['online', 'vehicle_name', 'device_id'], ['desc', 'asc', 'asc']).sort((a, b) => (((a.online && a.online.state) && (b.online && b.online.state)) && ((a.ignition && a.ignition.state) && (!b.ignition || !b.ignition.state))) ? -1 : 1);
	}

	const getActiveMarkerInfo = (device_id) => {
		if (activeTreeItem && activeTreeItem.device_id === device_id) {
			let markerInfo = state.markers.find(marker => marker.device_id === device_id)
			if (markerInfo) {
				markerInfo.speed_unit = props.user.user.speed_unit
			}
			return markerInfo
		}
		else {
			return null
		}
	}

	let nogroups = null;

	const getNogroupsDevices = () => {
		if (nogroups != null) {
			return (
				<div className='tree-view no-groups-tree'>
					{
						sortFunc(state.groups[nogroups].value).map((entry, j) => {
							return (
								<TreeVehicleNode
									key={entry.device_id}
									{...entry}
									entry={entry}
									activeTreeItem={activeTreeItem}
									markerInfo={getActiveMarkerInfo(entry.device_id)}
									onTreeDeviceClick={onTreeDeviceClick}
									isInternalUser={isInternalUser(userRole)}
									showTripsHistory={showTripsHistory}
								/>
							)
						})
					}
				</div>
			)
		}
	}

	const treeHeaderHeight = document.getElementById('tree-header') && document.getElementById('tree-header').offsetHeight + 72
	// console.log(state, props);
	// console.log('STATE TrackTraceContainer: ', state);
	// console.log('TrackTraceContainer _map: ', _map);

	// console.log('PROPS TrackTraceContainer: ', props)
	// console.log('STATE TrackTraceContainer: ', state)

	return (
		<div>
			<div className="tracking-content" style={{ position: 'relative' }} >
				<GreyHeader title='Home' subtitle={props.company.company.name} />

				<main className={`gps-tracking ${showVehicleSidebar && activeTreeItem && 'showVehicleSidebar'}`} style={{ position: 'relative', clear: 'both' }}>
					<div className="track-container-wrap"><div className="track-container-inner">
						<div id="block-tree" style={{ width: '300px', float: 'left', position: 'relative', height: 'calc(100vh - 68px)' }}>
							<div
								id="split-bar"
								onMouseDown={(e) => handleSplitBarMouseDown(e)}
							>
								<div className="bar-toggle" title="Close" onMouseDown={(e) => handleBarToggleMouseDown(e)} />
							</div>

							<div className='vehicle-list-wrapper'>
								<h3 id='tree-header' className="vehicles-online-header">
									Vehicles Online: {initDevices.filter(device => device.online).length}/{initDevices.length}
								</h3>

								<div className='vehicles-list'>
									<SearchBar placeholder='Search Vehicles or Groups...' term={state.autoValue} onSearch={(e) => onChangeVehicleSearch(e.target.value)} />
									<h3 className='category-title'>Groups</h3>
									<div className="devices-tree" style={{ height: `calc(100vh - ${treeHeaderHeight + 93}px)` }}>
										{
											state.groups.map((node, i) => {
												if (node.id != 'null') {
													const type = node.id;
													const label = <CategoryItem
														className='node'
														small
														text={type}
														onClick={handleTreeClick.bind(this, i)}
														rightLabel={
															`${node.value.filter(device => device.online).length}/${node.value.length}`
														}
													/>
													return (
														<TreeView
															key={node.id}
															nodeLabel={label} // displays folders of the tree
															collapsed={collapsedBookkeeping[i]}
															onClick={handleTreeClick.bind(this, i)}
														>
															{
																sortFunc(node.value).map((entry, j) => {
																	return (
																		<TreeVehicleNode // displays vehicles in root of the tree
																			key={entry.device_id}
																			{...entry}
																			entry={entry}
																			activeTreeItem={activeTreeItem}
																			markerInfo={getActiveMarkerInfo(entry.device_id)}
																			onTreeDeviceClick={onTreeDeviceClick}
																			showTripsHistory={showTripsHistory}
																			isInternalUser={isInternalUser(userRole)}
																		/>
																	)
																})
															}
														</TreeView>
													)
												} else {
													nogroups = i;
												}
											})

										}

										{getNogroupsDevices()}

										{state.singleTrucks.length > 0
											&& (
												<div className="button-blue" style={{ marginTop: "10px" }}>
													<button className="btn btn-default" onClick={clearSingleTrucks} style={{ margin: "0" }}>Clear vehicle filter</button>
												</div>
											)}

									</div>
								</div>
							</div>
						</div>

						<div id="map-block" className={classnames(state.additionalClassName, { "hybrid": state.maptype == 'hybrid' })}>
							<div className="row1" style={{ marginRight: 0, position: 'relative' }}>
								<SimpleMapExampleGoogleMap
									userRole={userRole}
									containerElement={
										(isMobileOnly) ?
											<div style={{ height: `calc(100vh - 50px)` }} className='container-element' />
											:
											<div style={{ height: `calc(100vh - ${state.tripHeight}px - 82px)`, }} className='container-element' />
									}
									mapElement={
										<div style={{ height: `calc(100vh - 68px)` }} className='map-element' />
									}
									markers={state.markers}
									center={state.center}
									zoom={state.zoom}
									maptype={state.maptype}
									speed_unit={props.user.user.speed_unit}
									liveVideoUserAccess={liveVideoUserAccess()}
									polygons={state.polygons}
									snapRoadGPS={state.snapRoadGPS}
									singleTrucks={state.singleTrucks}
									showTripPanel={showTripPanel}
									onMapMounted={handleMapMounted}
									onSelectMarker={onSelectMarker}
									onClickAddress={onClickAddress}
									// onOpenLive      = {openLive}
									onZoomChanged={onZoomChangedManually}
									onMapTypeIdChanged={onMaptypeChangedManually}
									_map={_map}
									setMap={setMap}
									showLiveTraffic={state.showLiveTraffic}
									onClickLiveTraffic={onClickLiveTraffic}
									onClickSnapRoad={onClickSnapRoad}
									openClip={openClip}
									activeTreeItem={activeTreeItem}
								/>

								{/* Displays the Trip Snapshot Carousel --FWSD-4740 */}
								{selectedTrip && <TripSnapshots activeTreeItem={activeTreeItem} />}

								{(!state.company_trace_active) ? <div className="gray-map"></div> : ''}
							</div>


						</div> {/* END id="map-block" */}

						{/* Vehicle right sidebar */}
						<div className="vehicle-sidebar">
							<div className="wrapperSidebar">
								<button
									className={`vehicleSidebarToggle ${!activeTreeItem && 'disabled'}`}
									title={`${!activeTreeItem ? 'Select a vehicle first' : ''}`}
									disabled={!activeTreeItem}
									onClick={handleVehicleSidebarToggle}
								>
									<svg xmlns="http://www.w3.org/2000/svg" version="1.1" fill="currentColor" width="31.5" viewBox="0 0 612 612">
										<path d="M541.322,500.219v-94.372c0-20.277-16.438-36.716-36.715-36.716h-9.598V24.598c0-3.082-1.547-5.958-4.117-7.657   L467.587,1.537c-6.103-4.033-14.239,0.342-14.239,7.657v110.652l-6.945-18.734c-9.34-25.196-33.373-41.918-60.245-41.918H225.702   c-27.03,0-51.169,16.916-60.394,42.323l-6.655,18.329V9.194c0-7.314-8.137-11.69-14.24-7.657L121.107,16.94   c-2.571,1.699-4.118,4.575-4.118,7.657v344.534h-9.597c-20.277,0-36.715,16.438-36.715,36.716v94.372H55.035   c-5.069,0-9.178,4.109-9.178,9.179v50.743c0,5.069,4.109,9.179,9.178,9.179h39.598v24.322c0,10.139,8.219,18.357,18.358,18.357   h48.645c10.139,0,18.358-8.219,18.358-18.357V569.32h252.014v24.322c0,10.139,8.22,18.357,18.357,18.357h48.646   c10.139,0,18.357-8.219,18.357-18.357V569.32h39.598c5.07,0,9.179-4.11,9.179-9.179v-50.742c0-5.07-4.109-9.179-9.179-9.179   L541.322,500.219L541.322,500.219z M170.814,170.975h270.372v90.44H170.814V170.975z M164.527,474.533H133.17   c-9.581,0-17.348-7.768-17.348-17.349v-0.438c0-9.581,7.767-17.348,17.348-17.348h31.356c9.581,0,17.348,7.767,17.348,17.348v0.438   C181.875,466.765,174.108,474.533,164.527,474.533z M368.398,479.648H243.602c-10.139,0-18.358-8.22-18.358-18.357V344.976   c0-10.138,8.219-18.357,18.358-18.357h124.796c10.138,0,18.357,8.22,18.357,18.357v116.314   C386.756,471.428,378.536,479.648,368.398,479.648z M478.829,474.533h-31.356c-9.58,0-17.348-7.768-17.348-17.349v-0.438   c0-9.581,7.768-17.348,17.348-17.348h31.356c9.581,0,17.349,7.767,17.349,17.348v0.438   C496.178,466.765,488.41,474.533,478.829,474.533z M365.607,393.801H246.099c-5.019,0-9.087-4.068-9.087-9.088v-0.184   c0-5.019,4.068-9.086,9.087-9.086h119.508c5.019,0,9.087,4.067,9.087,9.086v0.184C374.694,389.733,370.626,393.801,365.607,393.801   z M365.607,357.085H246.099c-5.019,0-9.087-4.068-9.087-9.087v-0.184c0-5.018,4.068-9.086,9.087-9.086h119.508   c5.019,0,9.087,4.068,9.087,9.086v0.184C374.694,353.017,370.626,357.085,365.607,357.085z M365.607,467.232H246.099   c-5.019,0-9.087-4.068-9.087-9.087v-0.184c0-5.019,4.068-9.087,9.087-9.087h119.508c5.019,0,9.087,4.068,9.087,9.087v0.184   C374.694,463.164,370.626,467.232,365.607,467.232z M365.607,430.516H246.099c-5.019,0-9.087-4.068-9.087-9.086v-0.184   c0-5.019,4.068-9.087,9.087-9.087h119.508c5.019,0,9.087,4.068,9.087,9.087v0.184C374.694,426.448,370.626,430.516,365.607,430.516   z" />
									</svg>
								</button>
							</div>
							{showVehicleSidebar && activeTreeItem
								&& (
									<VehicleSidebar
										activeTreeItem={activeTreeItem}
										_map={_map}
										onClickPlayback={onClickPlayback}
										openAdvancedPlayer={openAdvancedPlayer}
									/>
								)}
						</div>

					</div>
					</div>
				</main> {/* END className='gps-tracking' */}



				{state.popover.show
					&& (
						<div id="popover-basic" role="tooltip" className="popover top" style={{ left: state.popover.left, top: state.popover.top }}>
							<div>
								<h3 className="popover-title">
									{state.popover.type}
								</h3>
								<a href="/" className="alert-remove" style={{ position: 'absolute', top: '2px', right: '3px' }} onClick={closePopover}>
									<span className="glyphicon glyphicon-remove"></span>
								</a>
							</div>
							<div className="popover-content">
								<div dangerouslySetInnerHTML={{ __html: state.popover.content }}></div>
								<div>
									{state.popover.event.event_id
										? (
											<a href="/" onClick={e => viewEventClip(e, state.popover.event)}>
												Event Clips (id={state.popover.event.event_id})
											</a>
										)
										: (
											(userRole !== 'sales_demo')
												? <a href='/' onClick={e => requestCustomAlertVideo(e, state.popover.event)}>Request Video</a>
												: <a href='javascript:void(0)' className='disabled'>Request Video</a>
										)
									}
									{state.popover.event.event_type === "UnknownDriver"
										&& (
											<div>
												<a href='/' onClick={(e) => handleIdentifyDriverClick(e, state.popover.event)}>Identify Driver</a>
											</div>
										)}
								</div>
							</div>
						</div>
					)}
			</div>

			{((!_.isEmpty(tripAdvancedPlayerEvent) && tripAdvancedPlayerEvent.uploading_status === 'VIDEO_UPLOADED') || state.showAdvancedPlayer)
				&& (
					<AdvancedPlayer
						event={state.selectedEvent || tripAdvancedPlayerEvent}
						onHide={onCloseEventVideoAll}
						openShareEvent={openShareEvent}
						onFlagEvent={onFlagEvent}
						isFlagged={(state.selectedEvent && state.selectedEvent.flagged) || (tripAdvancedPlayerEvent && tripAdvancedPlayerEvent.flagged)}
						openEventNote={openEventNote}
						note={(state.selectedEvent && state.selectedEvent.custom_event_type) || (tripAdvancedPlayerEvent && tripAdvancedPlayerEvent.custom_event_type)}
						updateDriver={updateDriver}
					/>
				)}

			{(!_.isEmpty(tripAdvancedPlayerEvent) && tripAdvancedPlayerEvent.uploading_status !== 'VIDEO_UPLOADED')
				&& (
					<EventViewSnapshotModal
						event={tripAdvancedPlayerEvent}
						onHide={() => props.setTripAdvancedPlayerEvent(null)}
					/>
				)}

			{(!_.isEmpty(tripShowShareEvent) || state.showShareEvent)
				&& (
					<EventShareModal
						event={state.selectedEvent || tripShowShareEvent}
						onHide={onCloseShareEvent}
					/>
				)}

			{state.showEventNote &&
				<EventNoteModal
					show={state.showEventNote}
					event={state.selectedEvent || tripAdvancedPlayerEvent}
					onHide={() => setState({ ...state, showEventNote: false })}
					company_name={props.company.company.name || user.company_name}
					partner_name={props.company.company.partner || user.partner_company_name}
					onSave={(note) => onSaveEventNote(note)}
				/>
			}
		</div>
	)
}

const mapStateToProps = ({ user, company, tripreplay, dashboardData }) => ({
	user,
	company,
	tripreplay,
	showTripsHistory: dashboardData.showTripsHistory,
	tripsGPS: dashboardData.tripsGPS,
	// tripsGPSSnapRoad: dashboardData.tripsGPSSnapRoad,
	selectedTrip: dashboardData.selectedTrip,
	tripTimelineTimestamp: dashboardData.tripTimelineTimestamp,
	tripAdvancedPlayerEvent: dashboardData.tripAdvancedPlayerEvent,
	tripShowShareEvent: dashboardData.tripShowShareEvent,
	showSnapRoad: dashboardData.showSnapRoad,
	dashboardRedirect: dashboardData.dashboardRedirect,
	deviceTrips: dashboardData.deviceTrips,
});

const mapDispatchToProps = dispatch => ({
	updateTripreplay: (tripreplay) => {
		dispatch({ type: 'GET_TRIPREPLAY_SUCCESS', payload: tripreplay });
	},
	setTripAdvancedPlayerEvent: (state) => {
		dispatch({ type: 'SET_TRIP_ADVANCED_PLAYER_EVENT', payload: state })
	},
	setTripShowShareEvent: (state) => {
		dispatch({ type: 'SET_TRIP_SHOW_SHARE_EVENT', payload: state })
	},
	setTripsGPSSnapRoad: (state) => {
		dispatch({ type: 'SET_TRIPS_GPS_SNAP_ROAD', payload: state })
	},
	setShowSnapRoad: (state) => {
		dispatch({ type: 'SET_SHOW_SNAP_ROAD', payload: state })
	},
	setShowTripsHistory: (state) => {
		dispatch({ type: 'SET_SHOW_TRIP_HISTORY', payload: state })
	},
	addTripsGPSPolygonPoint: (state) => {
		dispatch({ type: 'ADD_TRIPS_GPS_POLYGON_POINT', payload: state })
	},
	setSelectedTrip: (state) => {
		dispatch({ type: 'SET_SELECTED_TRIP', payload: state })
	},
	setDeviceTrips: (arr) => {
		dispatch({ type: 'SET_DEVICE_TRIPS', payload: arr })
	},
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	},
	// setDashboardRedirect: (state) => {
	// 	dispatch({ type: 'SET_DASHBOARD_REDIRECT', payload: state })
	// },
})

export default connect(mapStateToProps, mapDispatchToProps)(TrackTraceContainer);
